module.exports = __webpack_public_path__ + "media/src/assets/Images/Clock-abccd888aebb91c19a62c884a689a55a.svg";